<template>
    <div>
        <app-text
            v-show="getProp('deha.user.misc.widgets.' + listitemId + '.data.type') === 'wsh_id'"
            :required="getProp('deha.user.misc.widgets.' + listitemId + '.data.type') === 'wsh_id'"
            :label="'wirsindhandwerk-ID'"
            :data-source="'deha.user.misc.widgets.' + listitemId + '.data.id'"
            :maxlength="255"
        ></app-text>

        <div
            v-show="getProp('deha.user.misc.widgets.' + listitemId + '.data.type') === 'wsh_id'"
            class="fileeditor__property fileeditor__property--copyright-note"
        >
            <p v-html="$helpers.uiText('R104')"></p>
        </div>

        <app-text
            v-show="getProp('deha.user.misc.widgets.' + listitemId + '.data.type') === 'link'"
            :required="getProp('deha.user.misc.widgets.' + listitemId + '.data.type') === 'link'"
            :label="'Link'"
            :data-source="'deha.user.misc.widgets.' + listitemId + '.data.url'"
            pattern="^(https?:\/\/(www\.)?)?[\-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([\-a-zA-Z0-9@:%_\+.~#?\&\/\/=]*)$"
            autoformat="url"
            :maxlength="255"
        ></app-text>

        <div
            class="field-wrap field-text field-text--small"
            v-show="getProp('deha.user.misc.widgets.' + listitemId + '.data.note') !== ''"
            v-html="getProp('deha.user.misc.widgets.' + listitemId + '.data.note')"
        ></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R100'),
            help: this.$helpers.uiText('R101')
        });
    },
    props: {
        moduleId: String,
        listitemId: String
    },
    components: {
        'app-text': Text
    }
};
</script>
